import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryTariff extends FDictionary {
  dictionary = 'tariff';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
